import dynamic from "next/dynamic";
import RemoteWorkHeaderConfig from "./remote-work-header-config";
import RemoteWorkHeaderAdvancedConfig from "./remote-work-header-advanced-config";
const RemoteWorkHeaderComponent = dynamic(()=>import("./remote-work-header-component"));
export default {
    RemoteWorkHeaderComponent,
    RemoteWorkHeaderConfig,
    RemoteWorkHeaderAdvancedConfig
};
